import React, { Component } from "react";
import { connect } from "react-redux";
import Menu from "components/menu";
import config from "./config";

class HeatDiary extends Component {
  render() {
    return <Menu {...config} {...this.props} />;
  }
}

const mapStateToProps = (state) => {
  return {
    messages: state.intl.messages.containers.features.heatDiary,
    heatDiary: state.reducers.heatDiary,
  };
};

export default connect(mapStateToProps)(HeatDiary);
